import _ from "lodash";
import {Auth} from "../components/Authorization";
import {SnackBar} from "../components/common";
import {customFieldService} from "_services";
import {getActionData, refreshPage} from "_helpers";
import {alertMessages, customFieldConstants} from "_constants";
import {
    customFieldActionsCreator
} from "../components/v2/views/Vote/Sections/BodySection/Response/CustomField/CustomFieldUtils";

function getCustomField(id) {
    return (dispatch) => {
        dispatch(getActionData(customFieldConstants.GET_CUSTOM_FIELD_REQUEST));
        customFieldService.getCustomField(id)
            .then(response => {
                dispatch(getActionData(customFieldConstants.GET_CUSTOM_FIELD_SUCCESS, response.data));
            }).catch((error) => {
            if(_.get(error, 'response.status') === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(customFieldConstants.GET_CUSTOM_FIELD_FAILURE, {}, error));
            SnackBar.showMessage(alertMessages.GET_CUSTOM_FIELD_ERROR);
        });
    }
}

function updateCustomField(id, payload) {
    return (dispatch) => {
        dispatch(getActionData(customFieldConstants.UPDATE_CUSTOM_FIELD_REQUEST, {id, payload}));
        customFieldService.updateCustomField(id, payload)
            .then(response => {
                dispatch(getActionData(customFieldConstants.UPDATE_CUSTOM_FIELD_SUCCESS, response.data));
                SnackBar.showMessage(alertMessages.UPDATE_CUSTOM_FIELD_SUCCESS);
            }).catch((error) => {
            if(_.get(error, 'response.status') === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(customFieldConstants.UPDATE_CUSTOM_FIELD_FAILURE, {}, error));
            SnackBar.showMessage(alertMessages.UPDATE_CUSTOM_FIELD_ERROR);
        });
    }
}

function deleteCustomField(id) {
    return (dispatch) => {
        dispatch(getActionData(customFieldConstants.DELETE_CUSTOM_FIELD_REQUEST, {id}));
        customFieldService.deleteCustomField(id)
            .then(response => {
                dispatch(getActionData(customFieldConstants.DELETE_CUSTOM_FIELD_SUCCESS, response.data));
                dispatch(customFieldActions.removeCustomFieldFromStore(id));
                SnackBar.showMessage(alertMessages.DELETE_CUSTOM_FIELD_SUCCESS);
            }).catch((error) => {
            if(_.get(error, 'response.status') === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(customFieldConstants.DELETE_CUSTOM_FIELD_FAILURE, {}, error));
            SnackBar.showMessage(alertMessages.DELETE_CUSTOM_FIELD_ERROR);
        });
    }
}

function removeCustomFieldFromStore(id) {
    return (dispatch) => {
        dispatch(getActionData(customFieldConstants.REMOVE_CUSTOM_FIELD_FROM_STORE, {id}))
    }
}

function createCustomField(msgDataSourceId, payload) {
    return (dispatch) => {
        dispatch(getActionData(customFieldConstants.CREATE_CUSTOM_FIELD_REQUEST, {id: msgDataSourceId}));
        customFieldService.createCustomField(payload)
            .then(response => {
                dispatch(getActionData(customFieldConstants.CREATE_CUSTOM_FIELD_SUCCESS, response.data));
                dispatch(listCustomFields(msgDataSourceId, customFieldActionsCreator.settingsView));
                SnackBar.showMessage(alertMessages.CREATE_CUSTOM_FIELD_SUCCESS);
            }).catch((error) => {
            if(_.get(error, 'response.status') === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(customFieldConstants.CREATE_CUSTOM_FIELD_FAILURE, {}, error));
            SnackBar.showMessage(alertMessages.CREATE_CUSTOM_FIELD_ERROR);
        });
    }
}

function fetchCustomFields(msgDataSourceId) {
    return (dispatch) => {
        dispatch(getActionData(customFieldConstants.FETCH_CUSTOM_FIELDS_REQUEST, { id: msgDataSourceId }));
        customFieldService.fetchCustomFields(msgDataSourceId)
            .then(response => {
                dispatch(getActionData(customFieldConstants.FETCH_CUSTOM_FIELDS_SUCCESS, response.data));
            }).catch((error) => {
            if(_.get(error, 'response.status') === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(customFieldConstants.FETCH_CUSTOM_FIELDS_SUCCESS, {}, error));
            SnackBar.showMessage(alertMessages.LIST_CUSTOM_FIELDS_ERROR);
        });
    }
}

function listCustomFields(msgDataSourceId, action) {
    return (dispatch) => {
        dispatch(getActionData(action.request));
        return customFieldService.listCustomFields(msgDataSourceId)
            .then(response => {
                dispatch(getActionData(action.success, response.data));
            }).catch((error) => {
            if(_.get(error, 'response.status') === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(action.failure, {}, error));
            SnackBar.showMessage(alertMessages.LIST_CUSTOM_FIELDS_ERROR);
        });
    }
}

function resetCustomFieldList() {
    return (dispatch) => {
        dispatch(getActionData(customFieldConstants.CLEAR_CUSTOM_FIELDS));
    }
}

export const customFieldActions = {
    getCustomField,
    updateCustomField,
    deleteCustomField,
    createCustomField,
    fetchCustomFields,
    listCustomFields,
    resetCustomFieldList,
    removeCustomFieldFromStore
};